import { useEffect, useRef, useState } from "react";

interface ExpandableTextProps {
  text?: string;
}

const ExpandableText: React.FC<ExpandableTextProps> = ({ text = "" }) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const [isOverflowing, setIsOverflowing] = useState<boolean>(false);
  const textRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (textRef.current) {
      const isTextOverflowing =
        textRef.current.scrollHeight > textRef.current.clientHeight;
      setIsOverflowing(isTextOverflowing);
    }
  }, [text]);

  const toggleExpand = () => setIsExpanded((prev) => !prev);

  return (
    <div style={{ maxWidth: "100%" }}>
      <div
        ref={textRef}
        style={{
          display: "-webkit-box",
          WebkitBoxOrient: "vertical" as const,
          overflow: "hidden",
          WebkitLineClamp: isExpanded ? "unset" : 2,
          whiteSpace: isExpanded ? "normal" : "pre-line",
        }}
      >
        {text}
      </div>

      {isOverflowing && (
        <button
          onClick={toggleExpand}
          style={{
            background: "none",
            border: "none",
            color: "royalblue",
            cursor: "pointer",
            padding: 0,
          }}
        >
          {isExpanded ? "Show Less" : "Show More"}
        </button>
      )}
    </div>
  );
};

export default ExpandableText;
